export default __webpack_public_path__ + "static/media/Mulish-Regular.d3d302e1.ttf";